import Footer from '../components/footer/Footer';
import Navbar from '../components/navbar/Navbar';
import StudentList from '../components/studentList/StudentList';

export default function Students() {
    return (
        <>
            <Navbar />
            <StudentList />
            <Footer />
        </>
    );
}
